<template>
  <edit-dialog
      :dialog="dialog"
      :valid="true"
      @close="handleClose"
      @save="handleSaveAndClear"
  >
    <template #title>Models In Scope</template>
    <template #body>
      <v-container fluid>
        <v-card outlined class="mb-3">
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
            Manual Actions
            <v-spacer></v-spacer>
            <v-checkbox v-model="checkboxes.productNumberChecked"
                        v-if="shouldShowFieldCheckbox(DocumentFields.ProductNr)"
                        label="Product No."
                        class="mr-2"></v-checkbox>
            <v-checkbox v-model="checkboxes.poscodeChecked"
                        v-if="shouldShowFieldCheckbox(DocumentFields.PosCode)"
                        label="POS Code"
                        class="mr-2"></v-checkbox>
            <v-checkbox v-model="checkboxes.materialChecked"
                        v-if="shouldShowFieldCheckbox(DocumentFields.Material)"
                        label="Material"
                        class="mr-2"></v-checkbox>
            <v-checkbox v-model="checkboxes.serialFromChecked"
                        v-if="shouldShowFieldCheckbox(DocumentFields.SerialNrFrom)"
                        label="Serial From"
                        :class="['mr-2', {'serial-warning-label': hasHiddenContent('serialFrom')}]"
                        class="mr-2"></v-checkbox>
            <v-checkbox v-model="checkboxes.serialToChecked"
                        v-if="shouldShowFieldCheckbox(DocumentFields.SerialNrTo)"
                        label="Serial To"
                        :class="['mr-2', {'serial-warning-label': hasHiddenContent('serialTo')}]"
                        class="mr-2"></v-checkbox>
            <v-btn icon @click="clearForm">
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pb-2 px-2">
            <v-form v-model="valid" ref="modelForm" lazy-validation>
              <v-row no-gutters class="mt-2">
                <v-col cols="12" sm="4">
                  <c-text-field
                      v-if="shouldShowField(DocumentFields.ProductNr)"
                      v-model="model.productNumber"
                      :readonly="!!model.appliedModelsXModelId"
                      label="Product number"
                      :class="$vuetify.breakpoint.smAndUp ? 'pr-1' : 'pb-2'"
                      @input="searchModelItemForAutofill()"
                  ></c-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <c-text-field
                      v-if="shouldShowField(DocumentFields.PosCode)"
                      :class="$vuetify.breakpoint.smAndUp ? 'px-1' : 'pb-2'"
                      v-model="model.poscode"
                      :readonly="!!model.appliedModelsXModelId"
                      label="POS Code"
                  ></c-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <c-text-field
                      v-if="shouldShowField(DocumentFields.Material)"
                      :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : 'pb-2'"
                      v-model="model.material"
                      :readonly="!!model.appliedModelsXModelId"
                      label="Material"
                  ></c-text-field>
                </v-col>
              </v-row>
              <v-row
                  no-gutters
                  :class="$vuetify.breakpoint.smAndUp ? '' : 'mt-0'"
              >
                <v-col cols="12" sm="6">
                  <c-select
                      :class="$vuetify.breakpoint.smAndUp ? 'pr-1 required' : 'pb-2 required'"
                      v-model="model.productGroupId"
                      :readonly="!!model.appliedModelsXModelId"
                      :items="productGroups"
                      label="Product Group"
                      :rules="[$common.rules.required]"
                  >

                  </c-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <c-select
                      :class="$vuetify.breakpoint.smAndUp ? 'pr-1 required' : 'pb-2 required'"
                      v-model="model.productSubGroupId"
                      :readonly="!!model.appliedModelsXModelId"
                      :items="productSubGroups"
                      label="Product Subgroup"
                      :rules="[$common.rules.required]"
                  >
                  </c-select>
                </v-col>
              </v-row>
              <v-row
                  no-gutters
                  :class="$vuetify.breakpoint.smAndUp ? '' : 'mt-0'"
              >
                <v-col cols="12" sm="6">
                  <v-text-field
                      v-if="shouldShowField(DocumentFields.SerialNrFrom)"
                      hide-details="auto"
                      :class="$vuetify.breakpoint.smAndUp ? 'pr-1' : 'pb-2'"
                      v-model="model.serialFrom"
                      label="Serial From"
                      outlined
                      dense
                      :rules="[$common.rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                      v-if="shouldShowField(DocumentFields.SerialNrTo)"
                      hide-details="auto"
                      :class="$vuetify.breakpoint.smAndUp ? 'pr-1' : 'pb-2'"
                      v-model="model.serialTo"
                      label="Serial To"
                      outlined
                      dense
                      :rules="[$common.rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col class="mt-2">
                  <v-btn color="primary" small class="mr-2" @click="save">
                    {{
                      model.appliedModelId ? "Update Model" : "Add Model"
                    }}
                  </v-btn>
                  <v-btn
                      color="success"
                      small
                      class="mr-2"
                      @click="downloadModelTemplate"
                  >
                    Download model definitions template
                  </v-btn>

                  <upload-button
                      @upload="postUpdatedModelDefinitions"
                      :loading="uploadLoading['modelTemplate']"
                  >
                    Upload updated model definitions template
                  </upload-button>
                  <upload-button
                      v-if="shouldShowField(DocumentFields.Exclusions)"
                      ref="exclusionFileInput"
                      @upload="uploadAndReplaceExclusions"
                      :loading="uploadLoading['exclusionTemplate']"
                  >
                    Upload model exclusions template (replace all)
                  </upload-button>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
        <v-card class="mt-3" outlined>
          <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
            Models In Scope
            <v-spacer></v-spacer>
            <v-badge
                v-if="$can('DownloadModelExcl', esv)"
                color="error"
                class="mr-5 mt-2"
                overlap
                :content="numberOfModelExclusions"
                :value="numberOfModelExclusions"
            >
              <v-btn
                  v-if="shouldShowField(DocumentFields.Exclusions)"
                  color="success"
                  small
                  @click="downloadExclusionRanges"
                  :disabled="!numberOfModelExclusions"
                  :loading="downloadExclusionRangesLoading"
              >
                Download exclusions
              </v-btn>              
            </v-badge>
            <v-btn
                v-if="shouldShowField(DocumentFields.Exclusions)"
                color="error"
                small
                class="mr-2 mt-2"
                @click="removeAllExclusions"
            >
              Remove all exclusions
            </v-btn>
          </v-card-title>
          <v-card-text class="py-2 pb-2">
            <v-data-table
                dense
                :headers="headers"
                :items="processedItems"
                :options.sync="options"
                @click:row="onRowClicked"
                :footer-props="{
                'items-per-page-options': [15, 50, 100, -1],
              }"
                :items-per-page="50"
                :item-class="() => 'cursor-pointer'"
                :server-items-length="totalItems"
            >
              <!-- For serial fields -->
              <template v-slot:item.serialFrom="{ item }">
                <span :class="{ 'serial-hidden-content-warning': item.serialFrom === '(hidden content)' }">
                  {{ item.serialFrom }}
                </span>
              </template>

              <template v-slot:item.serialTo="{ item }">
                <span :class="{ 'serial-hidden-content-warning': item.serialTo === '(hidden content)' }">
                  {{ item.serialTo }}
                </span>
              </template>
              <template v-slot:header="{ props: { headers } }">
                <data-table-search-header
                    :headers="headers"
                    :headerSelects="headerSelects"
                    @search="getAppliedModelsXModels"
                >
                  <template v-if="!readonly" #globalAction>
                    <v-btn small color="error" @click="removeAll"
                    >
                      Remove all
                    </v-btn
                    >
                  </template>
                </data-table-search-header>
              </template>
              <template v-if="!readonly" v-slot:item.actions="{ item }">
                <v-btn icon color="red" @click="deleteAppliedModelXModel(item)">
                  <v-icon class="mr-2"> mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
      <upload-report
          :dialog="uploadReportDialog"
          :uploadReport="uploadReport"
          @close="uploadReportDialog = false"
      ></upload-report>
    </template>
  </edit-dialog>
</template>

<script>
import EditDialog from "@/components/common/EditDialog.vue";
import exportTypes from "@/enums/ExportType";
import {FieldStatus} from "@/enums/FieldStatus";
import {DocumentFields} from "@/enums/DocumentFields";
// import UploadButton from "@/components/common/UploadButton.vue";
// import UploadReport from '@/components/Upload/UploadReport.vue'
// @ is an alias to /src

export default {
  name: "EditAppliedModelsXModel",
  components: {
    EditDialog,
    UploadButton: () => import("@/components/common/UploadButton.vue"),
    UploadReport: () => import("@/components/Upload/UploadReport.vue"),
    DataTableSearchHeader: () => import("@/components/common/DataTableSearchHeader.vue"),
  },
  props: {
    // model: Object,
    dialog: Boolean,
    // title: String,
    esvId: Number,
    esv: Object,
    readonly: Boolean,
  },
  data: () => ({
    autofillTimeout: null,
    valid: false,
    model: {
      serialFrom: '',
      serialTo: '',
    },
    productGroups: [],
    // productSubGroups: [],
    uploadReport: {},
    uploadReportDialog: false,

    checkboxes: {
      fetched: false,
      productNumberChecked: true,
      poscodeChecked: true,
      materialChecked: true,
      serialFromChecked: true,
      serialToChecked: true,
      productGroupChecked: true,
      productSubGroupChecked: true
    },
    initialCheckboxState: {
      productNumberChecked: null,
      poscodeChecked: null,
      materialChecked: null,
      serialFromChecked: null,
      serialToChecked: null,
    },
    initialContent: null,
    totalItems: null,
    options: {
      itemsPerPage: 50
    },
    loading: false,
    items: [],
    headers: [
      {
        text: "Product Number",
        value: "productNumber",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Material",
        value: "material",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "POS Code",
        value: "poscode",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Group",
        value: "productGroup",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Product Subgroup",
        value: "productSubGroup",
        type: "select",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Serial From",
        value: "serialFrom",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {
        text: "Serial To",
        value: "serialTo",
        type: "text",
        class: "text-subtitle-1 font-weight-bold",
      },
      {value: "actions", type: "action", sortable: false},
    ],
    headerSelects: [],
    search: [],
    uploadLoading: {
      modelTemplate: false,
      exclusionTemplate: false,
    },

    numberOfModelExclusions: 0,
    downloadExclusionRangesLoading: false,

    counter: 1
  }),

  methods: {
    hasHiddenContent(fieldName) {
      if (this.checkboxes[`${fieldName}Checked`]) {
        return false;
      }
      return this.items.some(item => {
        return item[fieldName] && item[fieldName].toString().trim() !== '';
      });
    },
    handleClose() {
      this.clearForm();
      this.$emit('close');
    },
    handleSaveAndClear() {
      this.saveFieldSettings();
      this.clearForm();
    },
    shouldShowFieldCheckbox(fieldPath) {
      const status = this.getFieldStatus(fieldPath);
      // Only show checkbox if field is not Keep (1) and not Disable (2)
      return status !== FieldStatus.Keep && status !== FieldStatus.Disable;
    },

    shouldShowField(fieldPath) {
      const status = this.getFieldStatus(fieldPath);
      // Show field if it's Keep (1) or if it's enabled and checked
      return status === FieldStatus.Keep ||
          (this.isFieldVisible(fieldPath) &&
              this.checkboxes[this.getCheckboxName(fieldPath)]);
    },

    getCheckboxName(fieldPath) {
      const mapping = {
        [DocumentFields.ProductNr]: 'productNumberChecked',
        [DocumentFields.PosCode]: 'poscodeChecked',
        [DocumentFields.Material]: 'materialChecked',
        [DocumentFields.SerialNrFrom]: 'serialFromChecked',
        [DocumentFields.SerialNrTo]: 'serialToChecked'
      };
      return mapping[fieldPath];
    },

    async saveFieldSettings() {
      const hasDataToHide = this.items.some(item => {
        return (
            // Check if we're hiding serial fields that contain data
            (!this.checkboxes.serialFromChecked && item.serialFrom) ||
            (!this.checkboxes.serialToChecked && item.serialTo)
        );
      });

      if (hasDataToHide) {
        const confirmed = await this.$confirm(
            "Warning: Changing serial field visibility will hide values. These values will be permanently deleted upon starting approval. Are you sure you want to continue?"
        );

        if (!confirmed) {
          return;
        }
      }

      try {
        const fieldSettings = {};

        if (this.shouldCheckField(DocumentFields.ProductNr)) {
          fieldSettings.productNumberChecked = this.checkboxes.productNumberChecked;
        }
        if (this.shouldCheckField(DocumentFields.PosCode)) {
          fieldSettings.poscodeChecked = this.checkboxes.poscodeChecked;
        }
        if (this.shouldCheckField(DocumentFields.Material)) {
          fieldSettings.materialChecked = this.checkboxes.materialChecked;
        }
        if (this.shouldCheckField(DocumentFields.SerialNrFrom)) {
          fieldSettings.serialFromChecked = this.checkboxes.serialFromChecked;
        }
        if (this.shouldCheckField(DocumentFields.SerialNrTo)) {
          fieldSettings.serialToChecked = this.checkboxes.serialToChecked;
        }

        await this.$api.updateFieldSettings(this.esvId, fieldSettings);

        // Store new state as initial state (but only for fields we actually updated)
        this.initialCheckboxState = {
          ...this.initialCheckboxState,
          ...fieldSettings
        };
        this.initialContent = [...this.items];

        await this.getAppliedModelsXModels();

        this.$emit('close');
      } catch (error) {
        console.error("Error updating field settings", error);
        this.$toast.error("Failed to update field settings.");
      }
    },
    shouldCheckField(fieldPath) {
      const status = this.getFieldStatus(fieldPath);
      return status !== FieldStatus.Keep && status !== FieldStatus.Disable;
    },
    shouldCheckboxBeCheckedByDefault(fieldPath) {
      const status = this.getFieldStatus(fieldPath);
      return FieldStatus.isEnabled(status);
    },
    getFieldStatus(fieldName) {
      return this.$common.getFieldStatus(this.$store, this.esv, fieldName);
    },
    isFieldVisible(fieldName) {
      return this.$common.isFieldVisible(this.$store, this.esv, fieldName);
    },
    setInitialCheckboxState() {
      if (this.checkboxes.productNumberChecked === null) {
        this.checkboxes.productNumberChecked = this.shouldCheckboxBeCheckedByDefault(DocumentFields.ProductNr);
      }
      if (this.checkboxes.poscodeChecked === null) {
        this.checkboxes.poscodeChecked = this.shouldCheckboxBeCheckedByDefault(DocumentFields.PosCode);
      }
      if (this.checkboxes.materialChecked === null) {
        this.checkboxes.materialChecked = this.shouldCheckboxBeCheckedByDefault(DocumentFields.Material);
      }
      if (this.checkboxes.serialFromChecked === null) {
        this.checkboxes.serialFromChecked = this.shouldCheckboxBeCheckedByDefault(DocumentFields.SerialNrFrom);
      }
      if (this.checkboxes.serialToChecked === null) {
        this.checkboxes.serialToChecked = this.shouldCheckboxBeCheckedByDefault(DocumentFields.SerialNrTo);
      }
    },
    save() {
      this.valid = this.$refs.modelForm.validate();

      if (!this.model.productGroupId || !this.model.productSubGroupId) {
        this.valid = false;
      }

      if (this.valid) {
        this.model.esvId = this.esvId;
        console.log("about to modelsend")
        const modelToSend = {
          ...this.model,
          // Clear values for all unchecked fields
          productNumber: this.checkboxes.productNumberChecked ? this.model.productNumber : '',
          poscode: this.checkboxes.poscodeChecked ? this.model.poscode : '',
          material: this.checkboxes.materialChecked ? this.model.material : '',
          serialFrom: this.checkboxes.serialFromChecked ? this.model.serialFrom : '',
          serialTo: this.checkboxes.serialToChecked ? this.model.serialTo : ''
        };

        this.$api.putAppliedModelsXModelUpdate(modelToSend)
            .then(() => {
              this.$emit("search");
              this.clearForm();
              this.getAppliedModelsXModels();
            });
      }
    },
    getProductGroups() {
      this.$api.getProductGroupProductSubGroups().then((resp) => {
        this.productGroups = resp.data;
        this.headerSelects["productGroup"] = resp.data;
      });
    },
    getAppliedModelsXModels(tableSearch) {
      if (!tableSearch) {
        tableSearch = [];
      }
      if ((!this.search || this.search.length < 1) && tableSearch.length >= 1) {
        this.search = tableSearch;
      }
      this.loading = true;


      this.options.id = this.esvId;
      var dtOptions = Object.assign({}, this.options);
      dtOptions.id = this.esvId
      this.$api.getAppliedModelsXModelsOverview(dtOptions, tableSearch)
          .then((resp) => {
            this.loading = false;
            this.items = resp.data.items;
            this.totalItems = resp.data.totalItems;
            this.numberOfModelExclusions = resp.data.numberOfModelExclusions;

            // Use the field settings from the response
            if (!this.checkboxes.fetched && resp.data.fieldSettingsViewModel) {
              this.checkboxes = {
                ...this.checkboxes,
                ...resp.data.fieldSettingsViewModel,
                fetched: true
              };
              this.initialCheckboxState = {
                productNumberChecked: resp.data.fieldSettingsViewModel.productNumberChecked,
                poscodeChecked: resp.data.fieldSettingsViewModel.poscodeChecked,
                materialChecked: resp.data.fieldSettingsViewModel.materialChecked,
                serialFromChecked: resp.data.fieldSettingsViewModel.serialFromChecked,
                serialToChecked: resp.data.fieldSettingsViewModel.serialToChecked,
              };
              this.initialContent = [...resp.data.items];
            }
          });
    },

    downloadModelTemplate() {
      this.$api.downloadModelTemplate(this.esvId, exportTypes.excel);
    },
    

    uploadAndReplaceExclusions(file) {
      this.$confirm("All existing exclusions will be removed and replaced with the new template. Do you want to continue?").then(
        (res) => {
          if (res) {
            var formData = new FormData();
            formData.append("Id", this.esvId);
            formData.append("File", file);

            this.uploadLoading["exclusionTemplate"] = true;

            this.$api
              .postExclusionTemplate(formData)
              .then((resp) => {
                this.uploadReport = resp.data;
                this.uploadReportDialog = true;
                this.getAppliedModelsXModels();
                this.$emit("search");
                this.$parent.suppressToastOnce = true;
              })
              .finally(() => {
                this.uploadLoading["exclusionTemplate"] = false;
                this.$refs.exclusionFileInput.resetFileInput();
              });
          }
        }
      );
    },

    postUpdatedModelDefinitions(file) {
      var formData = new FormData();
      if (!file) {
        console.error('No file provided');
        return Promise.reject('No file provided');
      }

      formData.append("Id", this.esvId);
      formData.append("File", file);

      const determineFieldStatus = (fieldName, checkbox) => {
        const currentStatus = this.getFieldStatus(fieldName);
        // If current status is Keep (1) or Disable (2), preserve it
        if (currentStatus === FieldStatus.Keep || currentStatus === FieldStatus.Disable) {
          return currentStatus;
        }
        // Otherwise use checkbox logic
        return checkbox ? FieldStatus.ShowEnabled : FieldStatus.Disable;
      };

      // Create DocumentFieldSettings array
      const documentFieldSettings = [
        {
          DocumentId: this.esvId,
          FieldName: DocumentFields.ProductNr,
          FieldStatus: determineFieldStatus(DocumentFields.ProductNr,
              this.checkboxes.productNumberChecked)
        },
        {
          DocumentId: this.esvId,
          FieldName: DocumentFields.PosCode,
          FieldStatus: determineFieldStatus(DocumentFields.PosCode,
              this.checkboxes.poscodeChecked)
        },
        {
          DocumentId: this.esvId,
          FieldName: DocumentFields.Material,
          FieldStatus: determineFieldStatus(DocumentFields.Material,
              this.checkboxes.materialChecked)
        },
        {
          DocumentId: this.esvId,
          FieldName: DocumentFields.ModelProductGroup,
          FieldStatus: determineFieldStatus(DocumentFields.ModelProductGroup,
              this.checkboxes.productGroupChecked)
        },
        {
          DocumentId: this.esvId,
          FieldName: DocumentFields.ModelProductSubgroup,
          FieldStatus: determineFieldStatus(DocumentFields.ModelProductSubgroup,
              this.checkboxes.productSubgroupChecked)
        },
        {
          DocumentId: this.esvId,
          FieldName: DocumentFields.SerialNrFrom,
          FieldStatus: determineFieldStatus(DocumentFields.SerialNrFrom,
              this.checkboxes.serialFromChecked)
        },
        {
          DocumentId: this.esvId,
          FieldName: DocumentFields.SerialNrTo,
          FieldStatus: determineFieldStatus(DocumentFields.SerialNrTo,
              this.checkboxes.serialToChecked)
        }
      ];

      formData.append("FieldSettings", JSON.stringify(documentFieldSettings));
      this.uploadLoading["modelTemplate"] = true;

      return this.$api.postUpdatedModelDefinitions(formData)
          .then((resp) => {
            this.uploadReport = resp.data;
            this.uploadReportDialog = true;
            this.getAppliedModelsXModels();
            this.$emit("search");
            this.clearForm();
          })
          .finally(() => {
            // Reset both loading state and file input since
            // new upload requires new file selection anyway
            this.uploadLoading["modelTemplate"] = false;
            const fileInput = document.querySelector('input[type="file"]');
            if (fileInput) {
              fileInput.value = '';
            }
          });
    },

    onProductGroupSelect() {
      if (this.search["productGroup"] && this.productGroups) {
        this.headerSelects["productSubGroup"] = this.productGroups.find(
            (pg) => pg.value == this.search["productGroup"]
        ).productSubGroups;
      }
    },

    onRowClicked(value) {
      this.model = Object.assign({}, value)
    },

    deleteAppliedModelXModel(item) {
      this.$api
          .deleteAppliedModelsXModel(item.appliedModelsXModelId, item.objectId)
          .then(() => {
            this.getAppliedModelsXModels();
            this.$emit("search");
            // this.$toast.success("Model has been removed");
            this.clearForm()
          });
    },
    removeAllExclusions() {
      this.$confirm("Are you sure you want to remove all exclusions?").then(
          (res) => {
            if (res) {
              this.$api.deleteAllExclusions(this.esvId).then(() => {
                this.getAppliedModelsXModels();
                this.$emit("search");
              });
            }
          }
      );
    },

    removeAll() {
      this.$confirm(
          "Are you sure you want to remove all models in scope?"
      ).then((res) => {
        if (res) {
          this.$api.deleteAllAppliedModelsXModels(this.esvId).then(() => {
            this.getAppliedModelsXModels();
            this.$emit("search");
            this.clearForm();
          });
        }
      });
    },

    clearForm() {
      this.model = {};
      this.$refs.modelForm.resetValidation();
    },

    downloadExclusionRanges() {
      this.downloadExclusionRangesLoading = true;
      this.$api
          .downloadExclusionRanges(this.esvId, exportTypes.excel)
          .finally(() => (this.downloadExclusionRangesLoading = false));
    },

    searchModelItemForAutofill() {
      // console.log('input')
      if (this.model.productNumber && this.model.productNumber.length > 5) {
        clearTimeout(this.autofillTimeout);
        this.autofillTimeout = setTimeout(() => {
          this.$api.searchModelItemForAutofill(this.model.productNumber)
              .then(resp => {
                if (resp.data && resp.data.number) {
                  this.$confirm(
                      "<p><strong>This number can be auto-filled</strong></p><p>Do you want to overwrite your input with the data found?</p>"
                  )
                      .then(confirm => {
                        if (confirm) {
                          this.model.productNumber = resp.data.number;

                          // Set fields based on visibility
                          if (this.checkboxes.poscodeChecked) {
                            this.model.poscode = resp.data.posCode;
                          }
                          if (this.checkboxes.materialChecked) {
                            this.model.material = resp.data.material;
                          }

                          this.model.productGroupId = resp.data.productGroupId;
                          this.model.productSubGroupId = resp.data.productSubGroupId;

                          // this.$forceUpdate();
                          this.counter++;
                        }
                      })
                }
              });
        }, 500);
      }
    }
  },

  mounted() {
    this.getProductGroups();
    this.getAppliedModelsXModels();
    // this.getProductSubGroups()

    this.$watch(() => this.search["productGroup"], this.onProductGroupSelect);
  },
  computed: {
    DocumentFields() {
      return DocumentFields
    },
    processedItems() {
      return this.items.map(item => ({
        ...item,
        productNumber: this.checkboxes.productNumberChecked == null
            ? item.productNumber
            : this.checkboxes.productNumberChecked
                ? item.productNumber
                : '',
        poscode: this.checkboxes.poscodeChecked == null
            ? item.poscode
            : this.checkboxes.poscodeChecked
                ? item.poscode
                : '',
        material: this.checkboxes.materialChecked == null
            ? item.material
            : this.checkboxes.materialChecked
                ? item.material
                : '',
        serialFrom: this.checkboxes.serialFromChecked == null
            ? item.serialFrom
            : this.checkboxes.serialFromChecked
                ? item.serialFrom
                : item.serialFrom ? '(hidden content)' : '',
        serialTo: this.checkboxes.serialToChecked == null
            ? item.serialTo
            : this.checkboxes.serialToChecked
                ? item.serialTo
                : item.serialTo ? '(hidden content)' : ''
      }));
    },
    productSubGroups() {
      this.counter;
      if (
          this.model.productGroupId &&
          this.productGroups
      ) {
        var productGroup = this.productGroups.find(
            (pg) => pg.value == this.model.productGroupId
        );
        if (productGroup) {
          return productGroup.productSubGroups;
        }
      }
      return [];
    },
  },
  watch: {
    dialog: {
      handler(newVal) {
        if (newVal) {
          this.setInitialCheckboxState();
        }
      },
      immediate: true
    },
    readonly: {
      handler() {
        if (this.readonly) {
          this.getAppliedModelsXModels();
        }
      }
    },
    options: {
      handler() {
        this.getAppliedModelsXModels();
      },
      deep: true
    }
  },
}
</script>

<style scoped>
.v-input--checkbox >>> label {
  color: black;
  font-size: 14px;
}

.required >>> fieldset {
  border-left: 3px solid dodgerblue;
}

.notRequired >>> fieldset {
  border-left: 1px solid;
}

.dotted >>> fieldset {
  border-left: 3px dotted dodgerblue;
}

/* .v-input--select >>> label {
    color: rgb(50, 53, 205); 
} */

/* .v-text-field :disabled >>> fieldset {
    background-color: yellowgreen ;
} */

/*.v-text-field >>> input[readonly="readonly"] {
    background-color: rgb(50, 66, 205) !important;
} */

.v-data-table
>>> .v-data-table__wrapper
tbody
tr.v-data-table__expanded__content {
  box-shadow: none;
}

.serial-warning-label >>> label {
  color: #ff4444 !important;
  font-weight: 500;
}

.hidden-content-warning {
  font-style: italic;
  font-size: 0.875rem;
}

.serial-hidden-content-warning {
  color: #ff4444;
  font-style: italic;
  font-size: 0.875rem;
}

</style>